import { AnimatePresence, motion } from 'framer-motion';

import { useLanguage } from '../LanguageContext';

export default function StoryContent({
  page,
  currentPageIndex,
  isLandscapeMode,
}) {
  const { t } = useLanguage();

  return (
    <div className="pt-[56px] pb-[72px] flex-grow flex flex-col min-h-0 overflow-y-auto">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentPageIndex}
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -15 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          className="flex-grow flex flex-col w-full min-h-full"
        >
          {/* HOME PAGE: full-screen background with overlay text */}
          <>
            {/* Cover Image for non-home pages */}
            {!page.hideImage && (
              <div
                className="relative overflow-hidden w-full shrink-0"
                style={{
                  height: isLandscapeMode ? '240px' : '360px',
                }}
              >
                <img
                  src={page.image}
                  alt={page.title || ''}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
              </div>
            )}

            {/* Page Component / Text */}
            <div
              className={`flex-grow w-full relative z-10 shadow-md bg-wedding-blush ${
                page?.hideImage ? '' : 'px-8 pt-8 pb-20'
              }`}
            >
              {!page.hideImage && (
                <div>
                  <h2 className="text-7xl text-banner-title text-center text-rose-accent">
                    {t(page.titleKey)}
                  </h2>
                  {page.subtitleKey && (
                    <p className="mt-1 text-3xl text-banner-subtitle text-center text-rose-accent">
                      {t(page.subtitleKey)}
                    </p>
                  )}
                </div>
              )}
              {page.mobileComponent || page.component}
            </div>
          </>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
